module.exports = __webpack_public_path__ + "img/design.94b027f1.svg";